import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button } from 'antd';
import { Link } from 'react-router';

import { formatNumber } from 'utils/formatting';
import _ from 'lodash';
import classes from '../styles/ScheduleInfo.module.scss';

const getStatus = (schedule) => {
  if (schedule.isDeleted === true) {
    return 'Cancelled';
  } else if (schedule.isClosed === true) {
    return 'Closed';
  } else if (schedule.isSummary === true) {
    return 'Completed';
  }
  return 'Upcoming';
};

const ScheduleHeader = ({ schedule, classroom, Tabs, isOffering, onOpenCancelModal, serviceFeeLevel }) => {
  const classRegisterDate = moment(classroom.createdAt).format('DD/MM/YYYY');
  const scheduleRegisterDate = moment(schedule.createdAt).format('DD/MM/YYYY');
  const scheduleStart = moment(schedule.start).format('DD/MM/YYYY');
  const scheduleEnd = moment(schedule.end).format('DD/MM/YYYY');
  const scheduleDuration = scheduleStart === scheduleEnd ? scheduleStart : `${scheduleStart} - ${scheduleEnd}`;
  const teacherLevel = _.get(schedule, 'class.owner.level');
  const forecastFeePercentage = serviceFeeLevel[teacherLevel];
  const status = getStatus(schedule);
  return (
    <div className={cn('content-header', classes.headerContainer)}>
      {schedule.isDeleted && <Alert message="Cancelled" type="error" description={' '} />}
      <Row className={classes.headerContent}>
        <Col xs={24}>
          {!isOffering && schedule.students.length === 0 && (
            <Button
              type="danger"
              disabled={schedule.studentEnroll !== 0 || schedule.isDeleted === true}
              onClick={() => schedule.studentEnroll === 0 && !schedule.isDeleted && onOpenCancelModal()}
              className={cn('pull-right', classes.marginRightBtn)}
            >
              Delete
            </Button>
          )}

          {isOffering && <h2>{"Teacher's Timetable"}</h2>}
          {!isOffering && <h2>Schedule: {scheduleDuration}</h2>}
          <div className="header-title">
            <span className="bold">Class: </span>
            <Link to={`/class/${classroom._id}`}>{classroom.name}</Link>
          </div>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={classroom.coverImage} />
          </div>
        </Col>
        <Col xs={9}>
          {isOffering ? (
            <div>
              <span className="bold">Class No.:</span> {classroom.classCode}
            </div>
          ) : (
            <div>
              <span className="bold">Schedule No.:</span> {schedule.code}
            </div>
          )}

          <div>
            <span className="bold">Teacher:</span> <Link to={`/teacher/${classroom.owner._id}`}>{classroom.owner.displayName}</Link>
          </div>
          <div>
            <span className="bold">Class Type: </span>
            {classroom.classType === 'single' && <span>Single</span>}
            {classroom.classType === 'multiple' && <span>Multiple</span>}
            {classroom.classType === 'flexible' && <span>Private</span>}
          </div>
          {isOffering ? (
            <div>
              <span className="bold">Create Date: </span>
              {classRegisterDate}
            </div>
          ) : (
            <div>
              <span className="bold">Create Date: </span>
              {scheduleRegisterDate}
            </div>
          )}
        </Col>
        {!isOffering && (
          <Col xs={9}>
            <div>
              <span className="bold">%Com Fee: </span>
              {schedule.serviceFeePercentage && `${schedule.serviceFeePercentage.normal}%, ${schedule.serviceFeePercentage.repeat}%`}
              {!schedule.serviceFeePercentage && `${_.get(forecastFeePercentage, 'normal')}%, ${_.get(forecastFeePercentage, 'repeat')}%[F]`}
            </div>
            <div>
              <span className="bold">%Com Disc: </span> {schedule.feeDiscount || 0}%
            </div>
            <div>
              <span className="bold">Status: </span> {status}
            </div>
          </Col>
        )}
      </Row>
      {schedule.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{schedule.remark}</span>
          </Col>
        </Row>
      )}
      {Tabs}
    </div>
  );
};

export default ScheduleHeader;

// if (value) {
//   return `${value.normal}%, ${value.repeat}%`;
// }
// const teacherLevel = _.get(schedule, 'class.owner.level');
// const feePercentage = this.props.serviceFeeLevel[teacherLevel];
// return `${feePercentage.normal}%, ${feePercentage.repeat}%[F]`;
